import React from "react";
import PropTypes from "prop-types";
import SeasonRecordsPairTable from "./SeasonRecordsPairTable";

const SeasonTeamRecordsTable = ({ bestTeamStats, worstTeamStats }) => (
    <SeasonRecordsPairTable bestStats={bestTeamStats} worstStats={worstTeamStats} loadingLabel="team records" />
);

SeasonTeamRecordsTable.propTypes = {
    bestTeamStats: PropTypes.array,
    worstTeamStats: PropTypes.array,
};

export default SeasonTeamRecordsTable;
